import { HttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateLangService } from '@core/services/translate-service/translate-lang.service';
import { AccessOrdererHistoryComponent } from '@mandants/telekom/features/access-orderer/access-orderer-history/access-orderer-history.component';
import { AccessOrdererComponent } from '@mandants/telekom/features/access-orderer/access-orderer.component';
import { EditAccessOrdererComponent } from '@mandants/telekom/features/access-orderer/edit-access-orderer/edit-access-orderer.component';
import { AdministrationComponent } from '@mandants/telekom/features/administration/administration.component';
import { ExtendRoleDialogComponent } from '@mandants/telekom/features/administration/extend-role-dialog/extend-role-dialog.component';
import { UpdateUserComponent } from '@mandants/telekom/features/administration/update-user/update-user.component';
import { ImprintTelekomComponent } from '@mandants/telekom/features/imprint/imprint.component';
import { LocationModule } from '@mandants/telekom/features/location/location.module';
import { PrivacyTelekomComponent } from '@mandants/telekom/features/privacy/privacy.component';
import { TelekomRemModule } from '@mandants/telekom/features/rem/telekom-rem.module';
import { SupportTelekomComponent } from '@mandants/telekom/features/support/support.component';
import { ProspectiveTenantsTelekomComponent } from '@mandants/telekom/features/tasks/prospective-tenants/prospective-tenants.component';
import { TaskDetailsTelekomComponent } from '@mandants/telekom/features/tasks/task-details/task-details.component';
import { TaskListDtagTelekomComponent } from '@mandants/telekom/features/tasks/task-list-dtag/task-list-dtag.component';
import { TaskListTelekomComponent } from '@mandants/telekom/features/tasks/task-list/task-list.component';
import { ApprovalDialogComponent } from '@mandants/telekom/features/tickets/approval-dialog/approval-dialog.component';
import { DenialDialogComponent } from '@mandants/telekom/features/tickets/denial-dialog/denial-dialog.component';
import { ReturnRequesterDialogComponent } from '@mandants/telekom/features/tickets/returnRequester-dialog/returnRequester-dialog.component';
import { TicketCreateOrderAccessTelekomComponent } from '@mandants/telekom/features/tickets/ticket-create/order-access/order-access.component';
import { TicketListDtagComponent } from '@mandants/telekom/features/tickets/ticket-list/ticket-list-dtag/ticket-list-dtag.component';
import { TicketListTelekomComponent } from '@mandants/telekom/features/tickets/ticket-list/ticket-list.component';
import { InvoiceSettingsComponent } from '@mandants/telekom/features/invoices/invoice-settings/invoice-settings.component';
import { InvoiceListComponent } from '@mandants/telekom/features/invoices/invoice-list/invoice-list.component';
import { ContractListComponent } from '@mandants/telekom/features/invoices/contract-list/contract-list.component';
import { UserCreateComponent } from '@mandants/telekom/features/user/create/user-create.component';
import { UserPermissionsComponent } from '@mandants/telekom/features/user/permissions/user-permissions.component';
import { WebsiteEditModule } from '@mandants/telekom/features/website-edit/website-edit.module';
import { OverrideModule } from '@mandants/telekom/override/override.module';
import { TelekomSharedModule } from '@mandants/telekom/telekom-shared.module';
import {
  TranslateLoader,
  TranslateModule,
  TranslatePipe,
} from '@ngx-translate/core';
import { ExceptFilterPipe, SafeHtmlPipe } from '@shared/pipes';
import { FilterPipe } from '@shared/pipes/filter.pipe';
import { SharedModule } from '@shared/shared.module';
import { FormlyInformationRowComponent } from '@shared/components/forms/custom-formly-components/formly-information-row/formly-information-row.component';

@NgModule({
  declarations: [
    TicketListTelekomComponent,
    TaskListTelekomComponent,
    TaskListDtagTelekomComponent,
    TaskDetailsTelekomComponent,
    SupportTelekomComponent,
    ImprintTelekomComponent,
    PrivacyTelekomComponent,
    TicketCreateOrderAccessTelekomComponent,
    ProspectiveTenantsTelekomComponent,
    AccessOrdererComponent,
    EditAccessOrdererComponent,
    AccessOrdererHistoryComponent,
    AdministrationComponent,
    ExtendRoleDialogComponent,
    UpdateUserComponent,
    UserPermissionsComponent,
    UserCreateComponent,
    DenialDialogComponent,
    ApprovalDialogComponent,
    ReturnRequesterDialogComponent,
    TicketListDtagComponent,
    ContractListComponent,
    InvoiceListComponent,
    InvoiceSettingsComponent
  ],
  imports: [
    TelekomSharedModule,
    SharedModule,
    LocationModule,
    TelekomRemModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateLangService,
        deps: [HttpClient],
      },
    }),
    OverrideModule,
    FilterPipe,
    ExceptFilterPipe,
    WebsiteEditModule,
    SafeHtmlPipe,
    MatDialogModule,
    TranslatePipe,
    FormlyInformationRowComponent,
  ],
  exports: [],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TelekomModule {}
